export const en = {
  daterange: {
    on: 'On {1}',
    to: '{1} to {2}',
    after: 'After {1}',
    before: 'Before {1}',
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    last: 'Last {1}',
    next: 'Next {1}',
  },
  pikaday: {
    today: 'Today',
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month',
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  },
};
